import { debounce, listen, resolveElement } from './uilts';

/**
 * @param {string} selector same as DOMQuerySelector
 * @returns {() => void}
 */
export function blockScrollPropagation(selector) {
  const el = resolveElement(selector)
  const events = []
  const handler = (e) => e.preventDefault();
  const options = {
    passive: false,
  }

  for (const eventName of ['mousedown', 'touchstart', 'pointerdown', 'wheel']) {
    events.push(listen(el, eventName, handler, options))
  }

  return () => {
    for (const remove of events) {
      remove();
    }
  }
}

export function createResultCollector(fn) {
  const tasks = []

  return [
    tasks,
    (...args) => {
      const result = fn(...args);

      tasks.push(result);

      return result;
    },
  ]
}

export function initGlobalScrollProgressBar(selector, scrollElement = document.documentElement, debounceTime = 100) {
  const progressEl = resolveElement(selector);
  const handler = debounce(() => {
    const progress = scrollElement.scrollTop / (scrollElement.scrollHeight - scrollElement.clientHeight);

    progressEl.style.setProperty('transform', `scaleX(${progress})`);
  }, debounceTime);

  progressEl.style.setProperty('width', '100%');
  progressEl.style.setProperty('transform', 'scaleX(0)');
  progressEl.style.setProperty('transform-origin', '0 0');
  listen(window, 'scroll', handler);
  listen(window, 'resize', handler);
}
